<template>
  <div class="content">
    <div
      :class="['top_menu', getRouterPath != '/home' ? 'other_menu-style' : '']"
    >
      <el-row>
        <el-col :xs="24" :sm="24" :md="8" :lg="8">
          <div class="left_logo">
            <img
              src="@/assets/logo.png"
              alt=""
              class="logo"
              @click="routerPage"
            />
            <p>
              <!-- <span class="sub_title">{{ loginInfo.versionInfo }}</span> -->
              <span class="logo_text">{{ loginInfo.applicationName }}</span>
            </p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="14" :lg="14">
          <div class="middle_menu">
            <el-menu
              background-color="transparent"
              text-color="#000"
              active-text-color="#f18a0a"
              :default-active="activeIndex"
              class="el-menu-demo"
              mode="horizontal"
            >
              <router-link
                :to="item.path"
                v-for="item in menuList"
                :key="item.key"
              >
                <el-menu-item
                  :index="item.path ? item.path : item.key"
                  @click="openDialog(item.path, item.name)"
                >
                  {{ item.name }}
                </el-menu-item>
              </router-link>
            </el-menu>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="2" :lg="2">
          <div class="right_login">
            <span @click="login">登录</span>
            <!-- <span>注册</span> -->
          </div>
        </el-col>
      </el-row>
    </div>
    <router-view class="middle_content" />
    <div class="footer">
      <!-- <i class="el-icon-location"></i> -->
      <p>地址：{{ loginInfo.addr }} 邮编 210036</p>
      <!-- <p><i class="el-icon-service"></i> 服务邮箱：service@yanshi.com</p> -->
      <!-- | 苏ICP05xxxx号。 -->
      <p>
        版权所有：{{ loginInfo.versionInfo
        }}<span class="visit_sum">访问量：{{ visitSum }}次</span>
      </p>
      <p>系统运维电话: 15295538180</p>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="20%"
      @close="dialogVisible = false"
    >
      <template v-if="transactionUsageData.length">
        <ul class="trans_usage">
          <li v-for="item in transactionUsageData" :key="item.url">
            <p>{{ item.name }}</p>
            <p class="clickAway" @click="openPage(item.url)">
              点击前往<i class="el-icon-right"></i>
            </p>
          </li>
        </ul>
      </template>
      <template v-else>
        <el-empty :image-size="200"></el-empty>
      </template>
    </el-dialog>
    <!-- <FloatingWindow
      title="温馨提示"
      content="<a href='http://jsip.jiangsu.gov.cn/art/2026/1/4/art_85036_11704895.html'>江苏省首批数据知识产权服务拟入库培育机构名单公布</a>"
      :imageUrl="require('@/assets/do2.png')"
      :width="260"
      :height="140"
      :showButton="flase"
      buttonText="立即体验"
      backgroundColor="rgba(240, 249, 235, 0.95)"
      borderColor="#ddd"
      @close="handleFloatingClose"
      style="z-index: 10000000"
    /> -->
  </div>
</template>

<script>
import FloatingWindow from "@/components/floatingAndDrifting/index.vue";
export default {
  components: {
    FloatingWindow,
  },
  data() {
    return {
      activeIndex: "/home",
      menuList: [
        { name: "首页", key: "1", path: "/home" },
        // {name:'存证公示',key:'2',path:'/depositCertificateFormula'},
        { name: "登记公示", key: "3", path: "/registerCertificateFormula" },
        { name: "信息公告", key: "4", path: "/infoPublic" },
        // {name:'勘误公告',key:'5',path:'/correctError'},
        { name: "常见问题", key: "6", path: "/question" },
        { name: "操作指引", key: "7", path: "/operationRedirect" },
        { name: "交易使用", key: "8", path: "" },
        { name: "相关链接", key: "9", path: "" },
      ],
      loginInfo: {},
      transactionUsageData: [],
      dialogVisible: false,
      title: "",
      getLinkOrFriendData: [],
      visitSum: 0,
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 1000);
  },
  created() {
    this.activeIndex = this.getRouterPath;
    this.queryLoginInfo(); //首页登录地址标题等
    //查询访问量
    this.queryVisitSum();
  },
  computed: {
    getRouterPath() {
      return this.$route.path;
    },
  },
  methods: {
    //首页登录地址标题等
    queryLoginInfo() {
      this.$https.get("/web_info/config/webConfig").then((res) => {
        if (res.code == 0) {
          this.loginInfo = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //查询访问量
    queryVisitSum() {
      this.$https.get("/web_info/config/visits").then((res) => {
        if (res.code == 0) {
          this.visitSum = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    routerPage() {
      this.$router.push("/home");
    },
    login() {
      window.open(this.loginInfo.loginUrl);
    },
    openDialog(path, title) {
      if (!path) {
        this.title = title;
        this.dialogVisible = true;
        if (title == "相关链接") {
          this.transactionUsageData = JSON.parse(
            JSON.stringify(this.loginInfo.friendlyLinkUrlJsonArray)
          );
        } else {
          //交易使用
          this.transactionUsageData = JSON.parse(
            JSON.stringify(this.loginInfo.otherLinkUrlJsonArray)
          );
        }
      }
    },
    openPage(url) {
      window.open(url);
    },
    handleFloatingClose() {
      console.log("悬浮窗口已关闭");
      // 处理关闭事件
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  height: 100%;
}
.top_menu {
  // display: flex;
  align-items: center;
  padding: 0 3%;
  box-sizing: border-box;
  justify-content: space-between;
  position: relative;
  z-index: 100000;
  padding: 20px 0;
  max-width: 1300px;
  margin: 0 auto;
  .left_logo {
    display: flex;
    p {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 20px;
      align-items: baseline;
      .sub_title {
        font-size: 16px;
        font-weight: 600;
        color: #000;
        letter-spacing: 6px;
      }
    }
  }
  .logo_text {
    font-size: 28px;
    color: #000;
    font-weight: 600;
    vertical-align: middle;
  }
  .middle_menu {
    // width:55%;
    text-align: center;
    li {
      font-size: 17px;
    }
  }
  .right_login {
    height: 56px;
    line-height: 56px;
    span {
      margin: 0 10px;
      display: inline-block;
      color: #000;
      cursor: pointer;
      font-size: 17px;
    }
  }
}
.other_menu-style {
  padding: 20px 5%;
  background-color: #78aade;
  max-width: 100%;

  .right_login span,
  .logo_text,
  ::v-deep .el-menu-item:not(.is-active),
  .sub_title {
    color: #fff !important;
  }
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.el-menu {
  display: flex;
  justify-content: center;
  li {
    font-weight: 600;
    &:hover {
      color: #f18a0a !important;
      background-color: transparent !important;
    }
  }
}
.middle_content {
  min-height: 900px;
  padding-bottom: 100px !important;
}
.footer {
  text-align: center;
  padding: 10px 0 0px;
  box-sizing: border-box;
  background: #070707;
  color: #fff;
  position: fixed;
  z-index: 100000;
  bottom: 0;
  width: 100%;
  p {
    margin-bottom: 15px;
    i {
      color: #f18a0a;
      margin-right: 5px;
    }
  }
}
@media screen and (max-width: 767px) {
  .other_menu-style {
    padding: 20px 2%;
    .logo {
      width: 49px;
      height: 40px;
    }
    .logo_text {
      font-size: 22px;
    }
    .middle_menu li {
      font-size: 12px;
    }
    .right_login {
      text-align: right;
      height: auto !important;
      line-height: inherit;
      span {
        font-size: 14px;
      }
    }
  }
}
::v-deep .el-dialog__header {
  background: #f2f7f8;
  border-bottom: 1px solid #ccc;
}
::v-deep .el-dialog__body {
  background: #f2f7f8;
}
.trans_usage {
  display: flex;
  flex-wrap: wrap;
  li {
    width: 100%;
    background: #fff;
    border-radius: 10px;
    padding: 10px 20px;
    font-size: 18px;
    margin: 0 2% 2% 0;
    p {
      margin: 20px 0;
    }
    .clickAway {
      color: #78aade;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.visit_sum {
  margin-left: 20px;
}
</style>
